import SEOHead from '@/components/base/SEOHead';

export default function Privacidad() {
  return (
    <>
      <SEOHead
        title="Política de Privacidad | Suvi Digital"
        description="Política de privacidad de Suvi Digital. Cómo protegemos y gestionamos tus datos personales como cliente o visitante de nuestro sitio web."
        keywords="politica privacidad Suvi Digital, proteccion datos personales, GDPR marketing digital"
        canonical="https://suvidigital.com/politica-de-privacidad"
        schemaType="WebPage"
      />
      <main className="min-h-screen">
        {/* Hero */}
        <section className="relative min-h-[320px] md:min-h-[380px] flex items-center overflow-hidden">
          <div className="absolute inset-0 animate-gradient bg-gradient-to-br from-primary-100 via-background-50 to-secondary-100" />
          <div className="absolute top-20 right-20 w-72 h-72 bg-primary-200/30 rounded-full blur-3xl animate-float-slow" />

          <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 xl:px-16 pt-24 md:pt-28">
            <div className="max-w-4xl">
              <span className="inline-block bg-primary-50 text-primary-600 text-sm font-semibold px-4 py-1.5 rounded-full mb-5 border border-primary-200/50">
                Legal
              </span>
              <h1 className="font-heading text-4xl md:text-5xl font-bold text-foreground-900 mb-5 leading-tight">
                Política de{' '}
                <span className="text-gradient">Privacidad</span>
              </h1>
              <p className="text-foreground-500 text-lg leading-relaxed max-w-2xl">
                Última actualización: Enero 2025
              </p>
            </div>
          </div>
        </section>

        {/* Content */}
        <section className="bg-white py-16 md:py-20">
          <div className="px-4 md:px-6 lg:px-10 xl:px-16">
            <div className="max-w-3xl mx-auto space-y-10">
              <div>
                <h2 className="font-heading text-2xl font-bold text-foreground-900 mb-4">1. Responsable del Tratamiento</h2>
                <p className="text-foreground-600 leading-relaxed text-sm md:text-base">
                  <strong>Suvi Digital</strong>, con domicilio en Lima, Perú, es responsable del tratamiento de los datos personales recogidos a través de este sitio web, formularios de contacto y servicios contratados. Puedes contactarnos en:{' '}
                  <a href="mailto:hernan@suvidigital.com" className="text-primary-600 hover:text-primary-700 transition-colors">hernan@suvidigital.com</a>
                </p>
              </div>
              <div>
                <h2 className="font-heading text-2xl font-bold text-foreground-900 mb-4">2. Datos que Recopilamos</h2>
                <p className="text-foreground-600 leading-relaxed text-sm md:text-base mb-3">
                  Podemos recopilar los siguientes datos personales:
                </p>
                <ul className="list-disc list-inside text-foreground-600 text-sm md:text-base space-y-1.5 leading-relaxed">
                  <li>Nombre y apellidos</li>
                  <li>Dirección de correo electrónico</li>
                  <li>Número de teléfono / WhatsApp</li>
                  <li>Nombre de empresa o agencia de viajes</li>
                  <li>Información proporcionada voluntariamente en mensajes o consultas</li>
                </ul>
              </div>
              <div>
                <h2 className="font-heading text-2xl font-bold text-foreground-900 mb-4">3. Finalidad del Tratamiento</h2>
                <p className="text-foreground-600 leading-relaxed text-sm md:text-base mb-3">
                  Utilizamos tus datos personales para:
                </p>
                <ul className="list-disc list-inside text-foreground-600 text-sm md:text-base space-y-1.5 leading-relaxed">
                  <li>Responder a consultas y solicitudes de información</li>
                  <li>Preparar propuestas comerciales personalizadas</li>
                  <li>Prestar los servicios contratados</li>
                  <li>Enviar comunicaciones relacionadas con nuestros servicios (solo si has dado tu consentimiento)</li>
                  <li>Cumplir con obligaciones legales</li>
                </ul>
              </div>
              <div>
                <h2 className="font-heading text-2xl font-bold text-foreground-900 mb-4">4. Base Legal</h2>
                <p className="text-foreground-600 leading-relaxed text-sm md:text-base">
                  La base legal para el tratamiento de tus datos es el consentimiento expreso que otorgas al completar nuestros formularios de contacto, así como la ejecución de un contrato cuando contratas nuestros servicios. Puedes retirar tu consentimiento en cualquier momento.
                </p>
              </div>
              <div>
                <h2 className="font-heading text-2xl font-bold text-foreground-900 mb-4">5. Conservación de Datos</h2>
                <p className="text-foreground-600 leading-relaxed text-sm md:text-base">
                  Conservamos tus datos personales durante el tiempo necesario para cumplir con las finalidades descritas. Los datos de contacto de prospectos se conservan por un máximo de 2 años desde la última interacción. Los datos de clientes se conservan durante la relación contractual y el período legal de prescripción.
                </p>
              </div>
              <div>
                <h2 className="font-heading text-2xl font-bold text-foreground-900 mb-4">6. Derechos del Usuario</h2>
                <p className="text-foreground-600 leading-relaxed text-sm md:text-base mb-3">
                  Tienes derecho a:
                </p>
                <ul className="list-disc list-inside text-foreground-600 text-sm md:text-base space-y-1.5 leading-relaxed">
                  <li>Acceder a tus datos personales</li>
                  <li>Solicitar la rectificación de datos inexactos</li>
                  <li>Solicitar la supresión de tus datos</li>
                  <li>Oponerte al tratamiento</li>
                  <li>Solicitar la limitación del tratamiento</li>
                  <li>Solicitar la portabilidad de tus datos</li>
                </ul>
                <p className="text-foreground-600 leading-relaxed text-sm md:text-base mt-3">
                  Para ejercer estos derechos, envía una solicitud a:{' '}
                  <a href="mailto:hernan@suvidigital.com" className="text-primary-600 hover:text-primary-700 transition-colors">hernan@suvidigital.com</a>
                </p>
              </div>
              <div>
                <h2 className="font-heading text-2xl font-bold text-foreground-900 mb-4">7. Seguridad</h2>
                <p className="text-foreground-600 leading-relaxed text-sm md:text-base">
                  Implementamos medidas técnicas y organizativas apropiadas para proteger tus datos personales contra acceso no autorizado, pérdida, alteración o divulgación. Utilizamos conexiones HTTPS, almacenamiento seguro y acceso restringido a la información.
                </p>
              </div>
              <div>
                <h2 className="font-heading text-2xl font-bold text-foreground-900 mb-4">8. Cookies y Tecnologías de Seguimiento</h2>
                <p className="text-foreground-600 leading-relaxed text-sm md:text-base">
                  Este sitio web utiliza cookies para mejorar la experiencia del usuario y analizar el tráfico. Puedes gestionar las preferencias de cookies a través de la configuración de tu navegador.
                </p>
              </div>
              <div>
                <h2 className="font-heading text-2xl font-bold text-foreground-900 mb-4">9. Cambios en esta Política</h2>
                <p className="text-foreground-600 leading-relaxed text-sm md:text-base">
                  Podemos actualizar esta política de privacidad periódicamente. Te recomendamos revisar esta página regularmente. La fecha de última actualización se indica al inicio del documento.
                </p>
              </div>
              <div>
                <h2 className="font-heading text-2xl font-bold text-foreground-900 mb-4">10. Contacto</h2>
                <p className="text-foreground-600 leading-relaxed text-sm md:text-base">
                  Para cualquier consulta sobre esta política de privacidad, contacta con nosotros a:{' '}
                  <a href="mailto:hernan@suvidigital.com" className="text-primary-600 hover:text-primary-700 transition-colors">hernan@suvidigital.com</a>
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}